export default "__VITE_ASSET__RbDnMo1J__"